
export default {
  computed: {
    socialMedia () {
      return this.$store.state.config.social_media;
    },
  },
};
